import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/use-auth'
import type React from 'react'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAuth()

  if (!isLoggedIn) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
